<template>
    <aside>
      <div class="logo" v-if="product != 'BUK'"><router-link to="/"><img src="@/assets/images/logo-bk.png"/></router-link></div>
      <div class="logo" v-if="product == 'BUK'"><router-link to="/"><img src="@/assets/images/logo.png"/></router-link></div>
      <nav class="nav">
          <ul>
          <li><a class="current" href="#">
              <svg class="default">
                  <use xlink:href="@/assets/images/sprite.svg#right-arrow"></use>
              </svg>Aktenzeichen {{this.fileNumber}} {{this.firstname}} {{this.name}}</a></li>
          </ul>
      </nav>
      <div class="info">
          <p><a href="#" @click="showHotlineModal(!modalHotline)">
              <svg>
              <use xlink:href="@/assets/images/sprite.svg#icons8-ringer-volume"></use>
              </svg>Kostenlose Hotline</a></p>
          <p class="bottom-link"><span><router-link to="/impressum"><svg>
                  <use xlink:href="@/assets/images/sprite.svg#new-window"></use>
              </svg>Impressum</router-link>
              </span><span><router-link to="/datenschutz">Datenschutz</router-link></span></p>
              <p class="bottom-link"><span><router-link to="/widerrufsbelehrung">Widerrufsbelehrung</router-link></span></p>
      </div>
    </aside>
</template>
<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'AsideMiniService',
  data() {
    return {
      fileNumber: '',
      firstname: '',
      name: '',
      product: '',
    };
  },
  methods: {
    ...mapMutations({
        showHotlineModal: 'setModalHotline'
      }),
  },
  computed: mapState({
    modalHotline: (state) => state.modalHotline
  }),
  created() {
    this.fileNumber = this.$route.query.az;
    this.firstname = this.$route.query.vorname;
    this.name = this.$route.query.nachname;
    this.product = this.$route.query.pr;
  },
}
</script>